document.addEventListener('DOMContentLoaded', () => {
  const slides         = document.querySelectorAll('.custom-announcement-bar__slide');
  const toggleButton   = document.querySelector('.custom-announcement-bar__toggle');
  const announcementBar = document.querySelector('.custom-announcement-bar');
  const anounce_normal = document.querySelectorAll('.custom-anouncement-normal');
  const anounce_special = document.querySelectorAll('.custom-anouncement-special');

  fetch('https://ipapi.co/json/')
    .then(response => response.json())
    .then(data => {
      if (data.country_code === "US") {
        anounce_normal.forEach(el => el.style.display = 'none');
        anounce_special.forEach(el => el.style.display = 'block');
      } else {
        anounce_normal.forEach(el => el.style.display = 'block');
        anounce_special.forEach(el => el.style.display = 'none');
      }
    })
    .catch(error => {
      console.error('Error detecting location:', error);
      anounce_normal.forEach(el => el.style.display = 'block');
      anounce_special.forEach(el => el.style.display = 'none');
    });





  let currentIndex     = 0;
  let interval         = null;
  let isPlaying        = true;

  const loadState = () => {
    const saved = localStorage.getItem('announcementBarState');
    if (saved) {
      isPlaying = saved === 'playing';
      toggleButton.classList.toggle('paused', !isPlaying);
    }
    if (isPlaying) startRotation();
  };

  const saveState = () =>
    localStorage.setItem('announcementBarState', isPlaying ? 'playing' : 'paused');

  const updateToggle = () =>
    toggleButton.classList.toggle('paused', !isPlaying);

  const togglePlayPause = () => {
    isPlaying = !isPlaying;
    isPlaying ? startRotation() : stopRotation();
    updateToggle();
    saveState();
  };

  // Show only the first slide
  slides.forEach((slide, i) => {
    slide.classList.toggle('active', i === 0);
  });

  // <-- Updated nextSlide here -->
  const nextSlide = () => {
    const oldIndex = currentIndex;
    const newIndex = (currentIndex + 1) % slides.length;

    // Fade out the old slide
    slides[oldIndex].classList.remove('active');

    // After fade-out, fade in the new one
    setTimeout(() => {
      slides[newIndex].classList.add('active');
      currentIndex = newIndex;
    }, 600);
  };

  const startRotation = () => {
    stopRotation();
    interval = setInterval(nextSlide, 5000);
  };

  const stopRotation = () => {
    clearInterval(interval);
  };

  toggleButton.addEventListener('click', togglePlayPause);
  announcementBar.addEventListener('mouseenter', () => {
    if (isPlaying) stopRotation();
  });
  announcementBar.addEventListener('mouseleave', () => {
    if (isPlaying) startRotation();
  });

  loadState();

  fetch('https://ipapi.co/json/')
    .then(response => response.json())
    .then(data => {

      if (data.country_code === "US") {
        anounce_normal.style.setProperty('display', 'none');
        anounce_special.style.setProperty('display', 'block');
      } else {
        anounce_normal.style.setProperty('display', 'block');
        anounce_special.style.setProperty('display', 'none');
      }
    })
    .catch(error => {
      console.error('Error detecting location:', error);
    });
});
